import { Rutas } from '@/constants/rutas';
import NewsIcon from '../../icons/news-icon';

export const NavigationNoticiasItems = [
    {
        title: 'Inicio',
        shortTitle: 'Inicio',
        path: Rutas.INICIO,
        id: 'inicio',
    },
    {
        title: 'Noticias',
        shortTitle: 'Noticias',
        path: Rutas.NOTICIAS,
        id: 'noticias',
        icon: <NewsIcon width={20} height={20} />,
    },
    {
        title: 'Noticias Flash',
        shortTitle: 'Flash',
        path: Rutas.NOTICIAS_FLASH,
        id: 'noticias-flash',
    },
    {
        title: 'Actividades',
        shortTitle: 'Actividades',
        path: Rutas.ACTIVIDADES,
        id: 'actividades',
    },
    {
        title: 'Tierlist',
        shortTitle: 'Tierlist',
        path: Rutas.TIER_LIST_PUBLIC,
        id: 'tierlist',
    },
    {
        title: 'Recomendaciones',
        shortTitle: 'Recomendaciones',
        path: Rutas.RECOMENDACIONES_ANALITICA_FANTASY,
        id: 'recomendaciones',
    },
    {
        title: 'Plantillas Públicas',
        shortTitle: 'Plantillas Públicas',
        path: Rutas.PLANTILLAS_PUBLICAS,
        id: 'plantillas-publicas',
    },
];
